import { render, staticRenderFns } from "./7introduce.vue?vue&type=template&id=29688d56&scoped=true&"
import script from "./7introduce.vue?vue&type=script&lang=js&"
export * from "./7introduce.vue?vue&type=script&lang=js&"
import style0 from "./7introduce.vue?vue&type=style&index=0&id=29688d56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29688d56",
  null
  
)

export default component.exports